import type { HtmlHTMLAttributes } from "react";
import type React from "react";

export default function BaseCard({
  children,
  props,
}: {
  children: React.ReactNode;
  props?: HtmlHTMLAttributes<HTMLDivElement>;
}) {
  return (
    <div
      {...props}
      className={`border border-grayscale-50 shadow-[0px_12px_24px_-4px] shadow-[#919eab1f] rounded-3xl flex print:p-0 p-6 ${props?.className}`}
    >
      {children}
    </div>
  );
}
